// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 408 ? "adb4837d" : chunkId) + "." + {"239":"3b0ddb880f338ff0","245":"5971dae58dffeaa6","408":"95e856dd78f38bba","587":"f6a345fd9975b663","635":"1c1ef86c410a2689","683":"57a0b107063be6e6","743":"33d5d5bd5addac8b","881":"62034facb51a8729","986":"81e6bcf5ea5623c0"}[chunkId] + ".js";
};